<template>
  <div class="label-container">{{ transportadora.labelTransportadora }}</div>
</template>

<script>
import TransportadoraDropdownItem from './transportadora-dropdown-item.js' 
export default TransportadoraDropdownItem
</script>

<style scoped>
  .label-container{
    width: 520px;
    white-space: break-spaces;
  }
</style>
